
export const defaultAppState = {
    cannedMessages: {},
    cannedMessageQueues: {},
    supervisorStatistics: {},
    supervisorTasks: {},
    monitoredMessages: [],
    workers: {},
    currentUser: {},
    currentReservations: {},
    currentTaskContext: {},
    currentTaskQueueList: {},
    currentTaskSwitchTimeStamp: {},
    currentSelectedCategory: {},
    taskQueueCategories: [],
    teamsView: {},
    customerDataList: [],
    config: {},
    parkingConversations: {},
    features: {
      conversationTransfer: {
        enabled: true,
        coldTransfer: true,
        multiParticipant: true
      }
    },
    allQueues: []
};

export default function (state = defaultAppState, action) {
    let currentState = state;
    switch (action.type) {
        case 'UPDATE_CannedMessages':
            currentState.cannedMessages = action.cannedMessages;
            return Object.assign({}, state, currentState);

        case 'UPDATE_CannedMessageQueues':
            currentState.cannedMessageQueues = action.cannedMessageQueues;
            return Object.assign({}, state, currentState);

        case 'UPDATE_SupervisorStatistics':
            currentState.supervisorStatistics = action.statistics;
            return Object.assign({}, state, currentState);

        case 'UPDATE_TaskBackLogs':
            currentState.supervisorTasks = action.logs; //from the "supervisorStatisticsActions"
            return Object.assign({}, state, currentState);

        case 'UPDATE_TaskMessages':
            currentState.monitoredMessages = action.messages; //from the "supervisorStatisticsActions"
            return Object.assign({}, state, currentState);

        case 'UPDATE_Workers':
            currentState.workers = action.workers; //from the "supervisorStatisticsActions"
            return Object.assign({}, state, currentState);

        case 'UPDATE_CurrentUser':
            currentState.currentUser = action.currentUser; //from the "supervisorStatisticsActions"
            return Object.assign({}, state, currentState);

        case 'UPDATE_Reservations':
            currentState.currentReservations = action.reservations; //from the "supervisorStatisticsActions"
            return Object.assign({}, state, currentState);

        case 'UPDATE_TaskContext':
            currentState.currentTaskContext = action.taskContext; //from the "supervisorStatisticsActions"
            return Object.assign({}, state, currentState);

        case 'UPDATE_TaskQueuesList':
            currentState.currentTaskQueueList = action.taskQueueList; //from the "CannedResponsesActions"
            return Object.assign({}, state, currentState);

        case 'UPDATE_TimeStamp':
            currentState.currentTaskSwitchTimeStamp = action.currentTaskSwitchTimeStamp;
            return Object.assign({}, state, currentState);

        case 'UPDATE_SelectedCategory':
            currentState.currentSelectedCategory = action.selectedCategory;
            return Object.assign({}, state, currentState);

        case 'UPDATE_TaskQueueCategories':
            currentState.taskQueueCategories = action.queueCategories;
            return Object.assign({}, state, currentState);

        case 'UPDATE_TeamsView':
            currentState.teamsView = action.agentDataTable;
            return Object.assign({}, state, currentState);

        case 'UPDATE_CustomerDataList':
            currentState.customerDataList = action.custDataList;
            return Object.assign({}, state, currentState);

        case 'UPDATE_Config':
            currentState.config = action.config;
            return Object.assign({}, state, currentState);

        case 'START_ParkingConversation':
            currentState.parkingConversations = {
                ...state.parkingConversations,
                [action.conversationSid]: true
            };
            return Object.assign({}, state, currentState);

        case 'CLEAR_ParkingConversation':
            const parkingConversations = { ...state.parkingConversations };
            delete parkingConversations[action.conversationSid];
            currentState.parkingConversations = parkingConversations;
            return Object.assign({}, state, currentState);

        case 'UPDATE_TeamsQueues':
            currentState.allQueues = action.allQueues;
            return Object.assign({}, state, currentState);

        default:
            return state;
    }
}
